/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductDto } from './ProductDto';
import {
    ProductDtoFromJSON,
    ProductDtoFromJSONTyped,
    ProductDtoToJSON,
} from './ProductDto';

/**
 * 
 * @export
 * @interface ProductTypeDto
 */
export interface ProductTypeDto {
    /**
     * 
     * @type {number}
     * @memberof ProductTypeDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductTypeDto
     */
    name: string;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof ProductTypeDto
     */
    readonly products: Array<ProductDto>;
}

/**
 * Check if a given object implements the ProductTypeDto interface.
 */
export function instanceOfProductTypeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

export function ProductTypeDtoFromJSON(json: any): ProductTypeDto {
    return ProductTypeDtoFromJSONTyped(json, false);
}

export function ProductTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'products': ((json['products'] as Array<any>).map(ProductDtoFromJSON)),
    };
}

export function ProductTypeDtoToJSON(value?: ProductTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

